import { useEffect, useRef, useState } from "react";
import XButton from "./XButton";
import ChevronIcon from "../../assets/icons/ChevronIcon.svg?react";

const containerClasses =
  "bg-surface text-content border border-border-light rounded-md";

const buttonClasses =
  "w-full! bg-surface! text-content! border-0! shadow-none! outline-none! " +
  "px-5! py-3! justify-start!";

const bodyClasses = "px-5 pt-3 pb-5";

const AccordionItem = ({ title, children, className, defaultOpen = true }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [height, setHeight] = useState("auto");
  const contentRef = useRef(null);
  useEffect(() => {
    if (contentRef.current) {
      setHeight(isOpen ? contentRef.current.scrollHeight : 0);
    }
  }, [isOpen, children]);
  return (
        <div className={`${containerClasses} ${className ?? ""}`}>
            <div>
                <XButton
                    variant="close"
                    className={buttonClasses}
                    onClick={()=>{setIsOpen(!isOpen)}}
                    aria-expanded={isOpen}
                >
                    <div className="flex justify-between items-center w-full!">
                        <h6 className="m-0!">{title}</h6>
                        <ChevronIcon className={`text-primary transition-transform duration-200 ease-in-out ${isOpen ? "rotate-180" : ""}`} />
                    </div>
                </XButton>
            </div>

            <div ref={contentRef}
                style={{
                    height: height,
                    overflow: "hidden",
                    transition: "height 0.5s ease"
                }}>
              <div className={bodyClasses}>
                  {children}
              </div>
            </div>
        </div>
  );
};

export default AccordionItem;